import OBase from './OBase';
import * as Geometry from '../geometry';
import * as GHMath from '../../math';
//import { ClipperLib } from 'js-clipper';

export default class OffsetCurve extends OBase{
    update(){
        let surfTree = this.getSurfaceObjectInput("Surface");
        let distTree = this.getFloatInput("Distance");

        let output = this.outputs['Surface'].paramObject;

        let dataTrees = [surfTree, distTree];
        let outDataTrees = [];
        Geometry.makeMultiplePairs(dataTrees, outDataTrees);

        var outTree = new Geometry.DataTree();
        for(let i = 0; i < outDataTrees[0].branches.length; i++){
            for(let j = 0; j < outDataTrees[0].branches[i].length; j++){
                let paths = outDataTrees[0].branches[i][j];
                let dist = outDataTrees[1].branches[i][j];

                //Offset Paths
                const joinType = ClipperLib.JoinType.jtRound;
                const endType = ClipperLib.EndType.etClosedPolygon;
                var result = new ClipperLib.Paths();
                var co = new ClipperLib.ClipperOffset(0.5, 0.1);
                co.AddPaths(paths, joinType, endType);
                co.Execute(result, dist);

                //Clean 
                var clean_path = ClipperLib.Clipper.CleanPolygons(result, 0.5);
                clean_path = ClipperLib.Clipper.SimplifyPolygons(clean_path, ClipperLib.PolyFillType.pftNonZero);
                
                outTree.add(clean_path, outDataTrees[0].paths[i])
            }
        }

        output.value = outTree;
    }
}


// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/EOffsetCurve.js